const routes = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Home/pages/HomePage.vue'
      ),
    meta: { requiresAuth: true },
    redirect: { name: 'Pin Types' },
    children: [
      {
        path: 'pin-types',
        name: 'Pin Types',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Home/pages/PinTypesPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'regions',
        name: 'Regions',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Home/pages/RegionsPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'entities',
        name: 'Entities',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Home/pages/EntitiesPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'entity-types',
        name: 'Entity Types',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Home/pages/EntityTypesPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'tags',
        name: 'Tags',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Home/pages/TagsPage.vue'
          ),
        meta: { requiresAuth: true },
      },
    ],
  },

  {
    path: '/scheduled',
    name: 'Content',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Content/pages/ContentPage.vue'
      ),
    meta: { requiresAuth: true },
    redirect: { name: 'Announcements' },
    children: [
      {
        path: 'announcements',
        name: 'Announcements',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/AnnouncementsPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'exclusives',
        name: 'Exclusives',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/ExclusivesPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'perks',
        name: 'Perks',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/PerksPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'pins',
        name: 'Pins',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/PinsPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'campaigns',
        name: 'Campaigns',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/CampaignsPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'data-stream',
        name: 'Data Stream',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/DataStreamPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'chats',
        name: 'Chats',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/ChatsPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'chat-stream',
        name: 'Chat Stream',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Content/pages/ChatStreamPage.vue'
          ),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/push-notifications',
    name: 'Push Notifications',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Notification/pages/PushNotificationsPage.vue'
      ),
    redirect: { name: 'Notifications' },
    meta: { requiresAuth: true },
    children: [
      {
        path: '/notifications',
        name: 'Notifications',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Notification/pages/NotificationPage.vue'
          ),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/entity',
    name: 'Entity',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Entity/pages/EntityPage.vue'
      ),
    meta: { requiresAuth: true },
    redirect: { name: 'In Review' },
    children: [
      {
        path: 'in-review',
        name: 'In Review',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Entity/pages/InReviewPage.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'reviewed',
        name: 'Reviewed',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Entity/pages/ReviewedPage.vue'
          ),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/subscribers',
    name: 'Subscriber',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Entity/pages/SubscribersPage.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/feeds',
    name: 'Feeds',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Feeds/pages/FeedsPage.vue'
      ),
    meta: { requiresAuth: true },
    redirect: { name: 'Chat' },
    children: [
      {
        path: 'chat',
        name: 'Chat',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/modules/Feeds/pages/ChatFeedPage.vue'
          ),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/profile-crawlers',
    name: 'Profile Crawlers',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Entity/pages/ProfileCrawlerPage.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/assets',
    name: 'Assets',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/modules/Assets/pages/AssetsPage.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/sign-in',
    name: 'Sign-In',
    component: () => import('@/modules/Auth/pages/AuthPage.vue'),
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

export default routes;
